/* eslint-disable import/extensions */
import {
  POST_CODE_REGEX,
  REQUIRED_FIELD_ERROR,
  REQUIRED_FIELD_ERROR_FEM,
  FIELD_INVALID,
} from '@masfront/common-b2c'
import { object, string } from 'yup'

export default object().shape({
  addressInput: string().label('dirección').required(REQUIRED_FIELD_ERROR_FEM),
  number: string().label('número').required(REQUIRED_FIELD_ERROR),
  floor: string().label('piso'),
  letter: string().label('letra'),
  postalCode: string()
    .matches(POST_CODE_REGEX, FIELD_INVALID)
    .label('código postal')
    .required(REQUIRED_FIELD_ERROR),
  otherInfo: string().nullable(),
  town: string().label('localidad').required(REQUIRED_FIELD_ERROR_FEM),
  province: string().label('provincia').required(REQUIRED_FIELD_ERROR_FEM),
})
